import React from 'react'
import { Badge, Pane, Text } from "evergreen-ui";
import {
    MESSAGES,
    isRobIn,
    isPortfolioMajor,
} from '../../../config/admissionRound'

const DetailClassInterviweLevel1 = ({ DataRegister }) => {
    return (
        <>

            {
                isRobIn("statusPortfolioRound", DataRegister.ROB_ID) ?
                    isPortfolioMajor(DataRegister.Major_MAJOR_ID) ?
                        (
                            <>
                                <Pane
                                    color="#ffffff"
                                    backgroundColor="#ff0000"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={16}
                                    fontFamily=""
                                    fontWeight={700}
                                    marginTop={10}
                                    display="flex" alignItems="center" justifyContent="center"
                                >
                                    <Text fontWeight={700} style={{ color: "#ffffff" }}>
                                        * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                    </Text>
                                </Pane>

                                <div className="d-flex">
                                    <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                    <div> {DataRegister.Major_MAJOR_CLASSROOM}</div>
                                </div>
                                <div className="d-flex">
                                    <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                    <div> {DataRegister.Major_MAJOR_CLASSROOM2} </div>
                                </div>
                                <div className="d-flex">
                                    <Text fontWeight={600}>
                                        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                        &nbsp;&nbsp; &nbsp;
                                    </Text>
                                    <div> {DataRegister.Major_MAJOR_CLASSROOM3} </div>
                                </div>
                            </>
                        )
                        :
                        (

                            <Text color="#fa0000ff" fontWeight={700}>
                                {MESSAGES.noInterviewAnnounce}
                            </Text>

                        )
                    :
                    (
                        <>
                            <Pane
                                color="#ffffff"
                                backgroundColor="#ff0000"
                                height="100%"
                                paddingY={4}
                                paddingX={5}
                                fontSize={16}
                                fontFamily=""
                                fontWeight={700}
                                marginTop={10}
                                display="flex" alignItems="center" justifyContent="center"
                            >
                                <Text fontWeight={700} style={{ color: "#ffffff" }}>
                                    * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                </Text>
                            </Pane>
                            <div className="d-flex">
                                <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                <div> {DataRegister.Major_MAJOR_CLASSROOM}</div>
                            </div>
                            <div className="d-flex">
                                <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                <div> {DataRegister.Major_MAJOR_CLASSROOM2} </div>
                            </div>
                            <div className="d-flex">
                                <Text fontWeight={600}>
                                    &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                    &nbsp;&nbsp; &nbsp;
                                </Text>
                                <div> {DataRegister.Major_MAJOR_CLASSROOM3} </div>
                            </div>
                        </>
                    )
            }


        </>

    )
}

export default DetailClassInterviweLevel1
